import React from "react"

const HighlightedText = (props) => (
    <span style={{ color: "#28a45b" }}>{props.children}</span>
)

export { HighlightedText };